import { TrainingActionTypes } from '../action/index';
import { TrainingState, initialState } from "../state/TrainingState";
import { TrainingActions } from '../action/TrainingActions';

export function trainingReducer(state: TrainingState = initialState, action: TrainingActions): TrainingState {
    switch (action.type) {
        case TrainingActionTypes.TRAINING_LIST:
            return {...state, loading: true, error: false, categories: null};
        case TrainingActionTypes.TRAINING_LIST_SUCCESS:
            return {...state, loading: false, error: false, categories: action.categories};
        case TrainingActionTypes.TRAINING_LIST_ERROR:
            return {...state, loading: false, error: true, categories: null};
        case TrainingActionTypes.TRAINING_LIST_CLIENT:
            return {...state, loadingClient: true, errorClient: false, categoriesClient: null};
        case TrainingActionTypes.TRAINING_LIST_CLIENT_SUCCESS:
            return {...state, loadingClient: false, errorClient: false, categoriesClient: action.categories};
        case TrainingActionTypes.TRAINING_LIST_CLIENT_ERROR:
            return {...state, loadingClient: false, errorClient: true, categoriesClient: null};
        case TrainingActionTypes.TRAINING_LIST_APPLIED:
            return {...state, loadingApplied: true, errorApplied: false, appliedTrainings: null};
        case TrainingActionTypes.TRAINING_LIST_APPLIED_SUCCESS:
            return {...state, loadingApplied: false, errorApplied: false, appliedTrainings: action.appliedTrainings};
        case TrainingActionTypes.TRAINING_LIST_APPLIED_ERROR:
            return {...state, loadingApplied: false, errorApplied: true, appliedTrainings: null};
        case TrainingActionTypes.TRAINING_CLEAR:
            return {...state, errorTrainingContent: false, trainingContent: null, quiz: null, errorQuiz: false};
        case TrainingActionTypes.LOAD_CONTENT:
            return {...state, loadingTrainingContent: true, errorTrainingContent: false, trainingContent: null};
        case TrainingActionTypes.LOAD_CONTENT_SUCCESS:
            return {...state, loadingTrainingContent: false, errorTrainingContent: false, trainingContent: action.content};
        case TrainingActionTypes.LOAD_CONTENT_ERROR:
            return {...state, loadingTrainingContent: false, errorTrainingContent: true, trainingContent: null};
        case TrainingActionTypes.LOAD_QUIZ:
            return {...state, loadingQuiz: true, errorQuiz: false, quiz: null};
        case TrainingActionTypes.LOAD_QUIZ_SUCCESS:
            return {...state, loadingQuiz: false, errorQuiz: false, quiz: action.quiz};
        case TrainingActionTypes.LOAD_QUIZ_ERROR:
            return {...state, loadingQuiz: false, errorQuiz: true, quiz: null};
        case TrainingActionTypes.SAVE_QUIZ:
            return {...state, loadingSaveQuiz: true, errorSaveQuiz: false};
        case TrainingActionTypes.SAVE_QUIZ_SUCCESS:
            return {...state, loadingSaveQuiz: false, errorSaveQuiz: false};
        case TrainingActionTypes.SAVE_QUIZ_ERROR:
            return {...state, loadingSaveQuiz: false, errorSaveQuiz: true};
        case TrainingActionTypes.SAVE_PROGRESS:
            return {...state, loadingSaveProgress: true, errorSaveProgress: false};
        case TrainingActionTypes.SAVE_PROGRESS_SUCCESS:
            return {...state, loadingSaveProgress: false, errorSaveProgress: false, progress: null};
        case TrainingActionTypes.SAVE_PROGRESS_ERROR:
            return {...state, loadingSaveProgress: false, errorSaveProgress: true};
        case TrainingActionTypes.GET_PROGRESS:
            return {...state, loadingGetProgress: true, errorGetProgress: false, progress: null};
        case TrainingActionTypes.GET_PROGRESS_SUCCESS:
            return {...state, loadingGetProgress: false, errorGetProgress: false, progress: action.progress};
        case TrainingActionTypes.GET_PROGRESS_ERROR:
            return {...state, loadingGetProgress: false, errorGetProgress: true, progress: null};
        case TrainingActionTypes.SAVE_STATUS:
            return {...state, loadingStatus: true, errorStatus: false};
        case TrainingActionTypes.SAVE_STATUS_SUCCESS:
            return {...state, loadingStatus: false, errorStatus: false};
        case TrainingActionTypes.SAVE_STATUS_ERROR:
            return {...state, loadingStatus: false, errorStatus: true};
        case TrainingActionTypes.TRAINING_CLEAR_ERRORS:
            return {...state, 
                loading: false,
                error: false,
                loadingClient: false,
                errorClient: false,
                loadingApplied: false,
                errorApplied: false,
                loadingTrainingContent: false,
                errorTrainingContent: false,
                loadingQuiz: false,
                errorQuiz: false,
                loadingSaveQuiz: false,
                errorSaveQuiz: false,
                loadingSaveProgress: false,
                errorSaveProgress: false,
                loadingGetProgress: false,
                errorGetProgress: false,
                loadingStatus: false,
                errorStatus: false
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/reducer/TrainingReducer.ts